import api from './api'
import CallHelper from '@/helpers/call.helper'

class RentingService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/renting', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.rentings]
            } else {
                data = response.data.rentings
            }

            return data
        },)
    }

    async getWithProperty(params = {}) {
        return api.get('/renting/property', params)
    }

    async getByTenant(params = {}) {
        return api.get('/renting/tenant', params)
    }

    async getInstance(uuid) {
        return api.get('/renting/' + uuid)
    }

    async create(renting) {
        return api.post('/renting', {
                property_uuid: renting.property_uuid,
                name: renting.name,
                type: renting.type,
                status: renting.status,
                started_at: renting.started_at,
                ended_at: renting.ended_at,
                rent: renting.rent,
                charges: renting.charges,
                vat: renting.vat,
                security_deposit: renting.security_deposit,
                reference_index_id: renting.reference_index_id,
            })
            .then(response => response.data);
    }

    async modify(renting) {
        return api.patch('/renting/' + renting.uuid, {
                property_uuid: renting.property_uuid,
                name: renting.name,
                type: renting.type,
                status: renting.status,
                started_at: renting.started_at,
                ended_at: renting.ended_at,
                rent: renting.rent,
                charges: renting.charges,
                vat: renting.vat,
                security_deposit: renting.security_deposit,
                reference_index_id: renting.reference_index_id,
            })
            .then(response => response.data)
    }

    async delete(renting) {
        return api.delete('/renting/' + renting.uuid)
            .then(response => response.data);
    }

    async addTenants(renting, params) {
        return api.post('/renting/' + renting.uuid + '/tenant', params)
        .then(response => response.data);
    }

    async addPersons(renting, params) {
        let returns = []

        params.persons.forEach((item) => {
            returns.push(api.post('/person/renting', {
                    renting_uuid: renting.uuid,
                    person_uuid: item,
                })
                .then(response => response.data)
            )
        })

        return returns
    }

    async addRentings(person, params) {
        let returns = []

        params.rentings.forEach((item) => {
            returns.push(api.post('/person/renting', {
                    renting_uuid: item,
                    person_uuid: person.uuid,
                })
                .then(response => response.data)
            )
        })

        return returns
    }

    async updateReferenceIndex(rentingUuid, params) {
        return api.patch('/renting/' + rentingUuid + '/update-reference-index', params)
            .then(response => response.data)
    }

    async cancelReferenceIndex(rentingUuid) {
        return api.patch('/renting/' + rentingUuid + '/cancel-reference-index')
            .then(response => response.data)
    }
}

export default new RentingService();
